import React, { useCallback, useEffect, useState, useContext, useMemo } from 'react';
import AdminHeader from 'components/header';
import LayoutContainer from 'components/layout/LayoutContainer';
import Card from 'components/inputs/Card';
import { Col, Row, Spinner } from 'react-bootstrap';
import {
  BsDownload,
  //BsEye,
  // BsFillFileEarmarkZipFill,
  BsSearch,
  // BsUpload,
} from 'react-icons/bs';
// import { RiDeleteBin6Line, RiFileExcel2Line } from 'react-icons/ri';
// import { FiUsers } from 'react-icons/fi';
// import DatePicker from 'components/inputs/DatePicker';
import * as _ from 'lodash';
// import Avatar from 'components/inputs/Avatar';
// import DummyImage from 'assets/images/icons/dummyImage.png';
import SearchBox from 'components/general/SearchBox';
import PropTypes from 'prop-types';
import { DOWNLOAD_CUSTOMERS, FETCH_CUSTOMER, FETCH_WIDGETS, WALLET_TRANSACTION } from 'actions/customer';
import { useDispatch, useSelector } from 'react-redux';
// import { startsWith } from 'components/common/utils';
// import Pagination from 'components/general/Pagination';
import ReactPagination from 'components/general/ReactPagination';
import Button from 'components/inputs/Button';
// import { RiDeleteBinLine } from 'react-icons/ri';
// import { FiEdit2 } from 'react-icons/fi';
import { Modal } from 'react-bootstrap';
import CustomerForm from './CustomerForm';
import moment from 'moment';
// import { AiOutlineFile, AiOutlineFileJpg, AiOutlineFilePdf } from 'react-icons/ai';
// import { FcVideoFile } from 'react-icons/fc';
// import { FaRegFileAudio } from 'react-icons/fa';
import DateTimePicker from 'components/inputs/DateTimePicker';
import { BiSort } from 'react-icons/bi';
import { cookie } from 'utils/cookies/cookies';
import { MdClear, MdClose } from 'react-icons/md';
import { Form, Formik } from 'formik';
import TextInput from 'components/inputs/Input';
import * as Yup from 'yup';
import Select from 'components/inputs/Select';
import { toast } from 'react-toastify';
import { CREATE_STATUS_CODE, MANAGE_CUSTOMERS } from 'components/common/constant';
// import { useHistory } from 'react-router-dom';
// import './customer.css';
// import { FaRegUser } from 'react-icons/fa';
import { FaUserFriends } from 'react-icons/fa';
import { FaUserAlt } from 'react-icons/fa';
import { FaAndroid } from 'react-icons/fa';
import { IoLogoAndroid } from 'react-icons/io';
import { FaApple } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import Footer from 'components/general/Footer';
// import chargeCoin from '../../assets/images/icons/chargeCoin.png';
import { FaRegUser } from 'react-icons/fa';
import { roundOfDigit } from 'components/common/utils';
import { FaRupeeSign } from 'react-icons/fa';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import { useLocation } from 'react-router-dom';
import { IoSearchOutline } from 'react-icons/io5';
import { FaFilter } from 'react-icons/fa';
import OffCanvas from 'components/inputs/OffCanvas';
import fileDownload from 'js-file-download';
import { Chip } from '@mui/material';

const CustomerList = () => {
  const [startDate, setStartDate] = useState(moment().startOf('day'));
  const [endDate, setEndDate] = useState(moment(new Date()).endOf('day'));
  const [showAdvanceFilterPopup, setShowAdvanceFilterPopup] = useState(false);
  const [advanceFilterData, setAdvanceFilterData] = useState({});

  // const history = useHistory();
  const { navigateTo, isAllowed } = useContext(NavContext);
  const location = useLocation(); // Get the current route
  const isAdminRoute = location.pathname.includes('/customers/admin'); // Check if the route is for admin
  const currentUserRole = cookie.get('user-role');

  // const initialSearch = useSelector((state) => state.customer.search);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  // const [allCustomerData, setAllCustomerData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  // const [file, setFile] = useState([]);
  const [sortByItem, setSortByItem] = useState({ item: '', order: '' });
  const [showWalletForm, setShowWalletForm] = useState(false);
  const [customerList] = useState({});
  const [pageWiseCustomerData, setPageWiseCustomerData] = useState([]);
  const customers = useSelector((state) => state.customer.customers);
  const isLoader = useSelector((state) => state.customer.isLoading);
  const page = useSelector((state) => state.customer.page);
  const totalData = useSelector((state) => state.customer.total);
  const limit = useSelector((state) => state.customer.limit);
  const totalPages = useSelector((state) => state.customer.totalPages);
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);
  const profileData = useSelector((state) => state.profile.userProfile);
  const isLoading = useSelector((state) => state.downloadingLoader.isLoading);

  const currentUserName = _.get(profileData, 'name', '');
  const customerData = customers.filter(({ id: id1 }) => pageWiseCustomerData.some(({ id: id2 }) => id2 === id1));
  const searchOptions = [
    { label: 'Basic Details', value: 'basic_details' },
    { label: 'RFID Tag', value: 'rfid' },
    { label: 'EVCC_ID', value: 'evcc' },
  ];

  const [selectedOption, setSelectedOption] = useState(searchOptions[0].value);
  const [searchText, setSearchText] = useState('');
  const [showSearchBar, setShowSearchBar] = useState(false);
  const searchIcon = <IoSearchOutline size={27} onClick={() => setShowSearchBar(true)} className="report-search-icon" />;

  // const totalusers = useSelector((state) => state.customer.customerData.);

  const getCustomer = useCallback(
    (value = {}) => {
      const finalSearch = value.searchText;

      if (finalSearch) {
        const customerData = {
          ...value,
          search: {
            [selectedOption]: finalSearch,
          },
          ...(isAdminRoute ? { isAdmin: true } : {}),
        };

        dispatch({
          type: FETCH_CUSTOMER.REQUEST,
          payload: customerData,
          cb: (res) => {
            if (_.get(res, 'status') === 200) {
              setPageWiseCustomerData(res.data.results);
            }
          },
        });
      } else {
        const data = isAdminRoute ? { ...value, isAdmin: true } : { ...value };

        dispatch({
          type: FETCH_CUSTOMER.REQUEST,
          payload: data,
          cb: (res) => {
            if (_.get(res, 'status') === 200) {
              setPageWiseCustomerData(res.data.results);
              onCloseAdvanceFilterPopup();
            }
          },
        });
      }
    },
    [selectedOption, isAdminRoute]
  );

  const getWidgets = useCallback((data = {}) => {
    dispatch({
      type: FETCH_WIDGETS.REQUEST,
      payload: data,
    });
  }, []);

  const walletTransaction = useCallback(
    (data = {}) => {
      dispatch({
        type: WALLET_TRANSACTION.REQUEST,
        payload: data,
        cb: (res) => {
          if (res) {
            if (_.get(res, 'status') === CREATE_STATUS_CODE) {
              toast.success('Transaction in wallet successfully');
              setShowWalletForm(false);
              getCustomer({ page });
            }
          }
        },
      });
    },
    [page]
  );

  // function showFile() {
  //   const file = document.getElementById('file');
  //   setFile((prev) => [...prev, file.files.item(0)]);
  // }

  // const onRemoveFile = (removedFile) => {
  //   const newFiles = file.filter((file) => file.name !== removedFile);
  //   setFile(newFiles);
  // };

  // const getCustomerDetail = useCallback((id) => {
  //   dispatch({ type: GET_CUSTOMER, payload: id });
  // }, []);
  //
  // const deleteCustomer = useCallback((id) => dispatch({ type: DELETE_CUSTOMER, payload: id }), []);

  useEffect(() => {
    getCustomer({ from: moment(startDate).utc(), to: moment(endDate).utc() });
    getWidgets();
  }, [getCustomer, getWidgets]);

  const dataFilter = useCallback(
    (searchVal) => {
      if (searchVal) {
        getCustomer({ searchText: searchVal });
      } else if (!_.isEmpty(advanceFilterData)) {
        getCustomer({ from: moment(startDate).utc(), to: moment(endDate).utc(), ...advanceFilterData });
      } else {
        getCustomer({ from: moment(startDate).utc(), to: moment(endDate).utc() });
      }
    },
    [getCustomer, startDate, endDate, advanceFilterData]
  );

  const handleAdvanceFilter = useCallback(
    (values) => {
      getCustomer({ from: moment(startDate).utc(), to: moment(endDate).utc(), ...values });
    },
    [getCustomer, startDate, endDate]
  );

  // useEffect(() => {
  //   setAllCustomerData(
  //     _.filter(customers, (item) => startsWith(_.get(item, 'name', ''), searchText) || startsWith(_.get(item, 'email', ''), searchText))
  //   );
  // }, [searchText, customers]);

  // const getSortByItem = (name, order, page, filterDateData) => {
  //   const sortedOrder = order || 'asc';
  //   if (page) {
  //     const data = {
  //       from: moment(startDate).format('YYYY-MM-DD HH:mm:ss'),
  //       to: moment(endDate).format('YYYY-MM-DD HH:mm:ss'),
  //       sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
  //       page: page.selected + 1,
  //     };
  //     endDate && getCustomer(data);
  //   } else if (page) {
  //     const data = {
  //       sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
  //       page: page.selected + 1,
  //     };
  //     getCustomer(data);
  //   } else if (filterDateData) {
  //     const data = {
  //       ...filterDateData,
  //       sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
  //     };
  //     endDate && getCustomer(data);
  //   } else {
  //     const data = {
  //       sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
  //     };
  //     getCustomer(data);
  //   }
  // };

  const getSortByItem = (name, order, page) => {
    const sortedOrder = order || 'asc';

    const data = {
      sortBy: `${sortedOrder === 'asc' ? '' : '-'}${name}`,
    };

    // Add page if available
    if (page) {
      data.page = page.selected + 1;
    }

    // ---------------------------------------
    // 1. PRIORITY: searchText present → IGNORE advance filters/date filters
    // ---------------------------------------
    if (searchText) {
      data.search = { [selectedOption]: searchText };
      return getCustomer(data);
    }

    // ---------------------------------------
    // 2. apply advanceFilterData if available
    // ---------------------------------------
    if (!_.isEmpty(advanceFilterData)) {
      Object.assign(data, advanceFilterData, {
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
      });
      return getCustomer(data);
    }

    // ---------------------------------------
    // 3. apply only date range (if advanceFilterData is empty)
    // ---------------------------------------
    if (startDate && endDate) {
      data.from = moment(startDate).utc();
      data.to = moment(endDate).utc();
      return getCustomer(data);
    }

    // ---------------------------------------
    // 4. fallback (only sort + optional page)
    // ---------------------------------------
    return getCustomer(data);
  };

  const handleSorting = (sortItem, dataItem) => {
    if (dataItem.item === sortItem) {
      const sortOrder = dataItem.order === 'asc' ? 'desc' : 'asc';
      setSortByItem({ item: sortItem, order: sortOrder });
      getSortByItem(sortItem, sortOrder);
    } else {
      setSortByItem({ item: sortItem, order: 'asc' });
      getSortByItem(sortItem, 'asc');
    }
  };

  const handlePageClick = useCallback(
    (page) => {
      if (sortByItem.item && sortByItem.order) {
        getSortByItem(sortByItem.item, sortByItem.order, page);
      } else if (searchText) {
        const data = {
          search: {
            [selectedOption]: searchText,
          },
          page: page.selected + 1,
        };
        getCustomer(data);
      } else if (!_.isEmpty(advanceFilterData)) {
        const data = {
          ...advanceFilterData,
          page: page.selected + 1,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        getCustomer(data);
      } else if (startDate && endDate) {
        const data = {
          page: page.selected + 1,
          from: moment(startDate).utc(),
          to: moment(endDate).utc(),
        };
        getCustomer(data);
      } else {
        const data = {
          page: page.selected + 1,
        };
        getCustomer(data);
      }
    },
    [sortByItem, searchText, selectedOption, isAdminRoute, advanceFilterData, startDate, endDate]
  );

  const handleCloseFormCustomer = () => {
    setShowForm(false);
    setIsEdit(false);
  };

  const handleSearch = (e, triggerSearch = false) => {
    const value = e.target.value;
    setSearchText(value);

    if (triggerSearch) {
      dataFilter(value);
    }
  };
  const handleClose = () => {
    setShowWalletForm(false);
  };

  // const getCustomerPermissions =
  //   !_.isEmpty(rolePermissionData) &&
  //   _.map(
  //     _.filter(rolePermissionData[0].permissions, (item) => item.name === 'getCustomers'),
  //     (data) => data.name
  //   );

  const search = (
    <div
      className="search-box-option"
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        gap: '1rem',
        width: '100%',
      }}
    >
      <div style={{ width: '45%' }}>
        <Select options={searchOptions} value={selectedOption} onChange={(selected) => setSelectedOption(selected)} placeholder="Search Option" />
      </div>
      <div style={{ width: '55%' }}>
        <SearchBox
          preIcon={<BsSearch />}
          value={searchText}
          onChange={(e) => handleSearch(e, false)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSearch(e, true);
            }
          }}
        />
      </div>
    </div>
  );

  const manageCustomerPermissions =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_CUSTOMERS),
      (data) => data.name
    );

  const WalletTransactionSchema = Yup.object().shape({
    message: Yup.string().required(t('customerList.message')),
    type: Yup.string().required(t('customerList.type')),
    amount: Yup.number().required(t('customerList.amount')),
  });
  const totalUserCount = useSelector((state) => state.customer.totalUserCount);
  const activeusers = useSelector((state) => state.customer.activeUser);
  const inactiveUser = useSelector((state) => state.customer.inactiveUser);
  const androidUser = useSelector((state) => state.customer.androidUser);
  const iosUser = useSelector((state) => state.customer.iosUser);

  const formatPhoneNumber = (item) => {
    return `+${_.get(item, 'country_code')} ${_.get(item, 'phone')}`;
  };

  const copyToClipboard = (text, type) => {
    navigator.clipboard.writeText(text);
    toast.success(`${type} copied!`);
  };

  const onCloseAdvanceFilterPopup = () => setShowAdvanceFilterPopup(false);

  const advanceFilterSchema = Yup.object().shape({
    sessionCount: Yup.number()
      .nullable()
      .integer('Session count must be a whole number')
      .min(1, 'Session count must be at least 1')
      .max(99999, 'Session count cannot be more than 5 digits')
      .typeError('Session count must be a valid number'),
    sessionOperator: Yup.string()
      .nullable()
      .when('sessionCount', {
        is: (val) => val !== undefined && val !== null && val !== '',
        then: (schema) => schema.required('Session operator is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
    avgRating: Yup.number()
      .nullable()
      .min(1, 'Rating must be at least 1')
      .max(5, 'Rating cannot be more than 5')
      .typeError('Rating must be a valid number'),
    avgOperator: Yup.string()
      .nullable()
      .when('avgRating', {
        is: (val) => val !== undefined && val !== null && val !== '',
        then: (schema) => schema.required('Average rating operator is required'),
        otherwise: (schema) => schema.notRequired(),
      }),
  });

  const operatorOptions = [
    { label: 'Equals (=)', value: '$eq' },
    { label: 'Greater than (>)', value: '$gt' },
    { label: 'Less than (<)', value: '$lt' },
    { label: 'Greater than or equal (≥)', value: '$gte' },
    { label: 'Less than or equal (≤)', value: '$lte' },
  ];

  const handleAdvanceFilterData = (data) => setAdvanceFilterData(data);

  const initialValues = !_.isEmpty(advanceFilterData) ? { ...advanceFilterData } : { sessionCount: null, sessionOperator: null };

  const downloadRatingReview = useCallback(() => {
    const startMoment = moment(startDate);
    const endMoment = moment(endDate);

    const startMonth = startMoment.month();
    const startYear = startMoment.year();
    const endMonth = endMoment.month();
    const endYear = endMoment.year();

    if (startMonth === endMonth && startYear === endYear) {
      const daysInMonth = startMoment.daysInMonth();
      const diffInDays = endMoment.diff(startMoment, 'days');

      if (diffInDays >= daysInMonth) {
        toast.error(`The date range exceeds ${daysInMonth} days. Please select a shorter range or download from Download Advance Report.`);
        return false;
      }
    } else {
      const startMonthDays = startMoment.daysInMonth();
      const remainingDaysInStartMonth = startMonthDays - startMoment.date() + 1;
      const daysInEndMonth = endMoment.date();

      const totalDays = remainingDaysInStartMonth + daysInEndMonth;

      if (totalDays > startMonthDays) {
        toast.error('The selected date range exceeds the allowed days. Please select a shorter range or download from Download Advance Report.');
        return false;
      }
    }
    if (searchText) {
      const data = {
        search: {
          [selectedOption]: searchText,
        },
        excel: true,
        ...(isAdminRoute ? { isAdmin: true } : {}),
      };

      dispatch({
        type: DOWNLOAD_CUSTOMERS.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === 200) {
            fileDownload(res.data, `${'Customer Management'}.xlsx`);
          }
        },
      });
    } else if (!_.isEmpty(advanceFilterData)) {
      const data = {
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
        excel: true,
        ...advanceFilterData,
        ...(isAdminRoute ? { isAdmin: true } : { is_deleted: true }),
      };
      dispatch({
        type: DOWNLOAD_CUSTOMERS.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === 200) {
            fileDownload(res.data, `${'Customer Management'}.xlsx`);
          }
        },
      });
    } else if (startDate && endDate) {
      const data = {
        from: moment(startDate).utc(),
        to: moment(endDate).utc(),
        excel: true,
        ...(isAdminRoute ? { isAdmin: true } : { is_deleted: true }),
      };

      dispatch({
        type: DOWNLOAD_CUSTOMERS.REQUEST,
        payload: data,
        cb: (res) => {
          if (_.get(res, 'status') === 200) {
            fileDownload(res.data, `${'Customer Management'}.xlsx`);
          }
        },
      });
    }
  }, [startDate, endDate, searchText, selectedOption, isAdminRoute, advanceFilterData]);

  const downloadFile = () => {
    downloadRatingReview();
  };

  const isAdvanceFilterAvailable = useMemo(() => !_.isEmpty(advanceFilterData), [advanceFilterData]);

  const chips = useMemo(() => {
    const data = [];

    const sessionLabel = (operator, value) => {
      switch (operator) {
        case '$gte':
          return `Session >= ${value}`;
        case '$lte':
          return `Session <= ${value}`;
        case '$eq':
          return `Session = ${value}`;
        case '$gt':
          return `Session > ${value}`;
        case '$lt':
          return `Session < ${value}`;
        default:
          return '';
      }
    };

    const ratingLabel = (operator, value) => {
      switch (operator) {
        case '$gte':
          return `Average rating >= ${value}`;
        case '$lte':
          return `Average rating <= ${value}`;
        case '$eq':
          return `Average rating = ${value}`;
        case '$gt':
          return `Average rating > ${value}`;
        case '$lt':
          return `Average rating < ${value}`;
        default:
          return '';
      }
    };

    // SESSION FILTER CHIP
    if (advanceFilterData.sessionCount && advanceFilterData.sessionOperator) {
      data.push({
        key: 'sessionCount',
        label: sessionLabel(advanceFilterData.sessionOperator, advanceFilterData.sessionCount),
      });
    }

    // RATING FILTER CHIP
    if (advanceFilterData.avgRating && advanceFilterData.avgOperator) {
      data.push({
        key: 'avgRating',
        label: ratingLabel(advanceFilterData.avgOperator, advanceFilterData.avgRating),
      });
    }

    return data;
  }, [advanceFilterData]);

  const handleDeleteChip = (key) => {
    setAdvanceFilterData((prev) => {
      const updated = { ...prev };

      if (key === 'sessionCount') {
        delete updated.sessionCount;
        delete updated.sessionOperator;
      }

      if (key === 'avgRating') {
        delete updated.avgRating;
        delete updated.avgOperator;
      }

      handleAdvanceFilter(updated);

      return updated;
    });
  };

  const handleClearAllFilters = () => {
    setAdvanceFilterData({});
    getCustomer({ from: moment(startDate).utc(), to: moment(endDate).utc() });
  };

  return (
    <>
      <LayoutContainer>
        <AdminHeader title={t('header.customerManagement')} />
        <SkeletonTheme baseColor="#1b2a38" highlightColor="#15212b" enableAnimation="true">
          <div className="page-content-wrapper scrollable">
            <div className="customer-management-page__main">
              <div className="customer-details--block">
                {isAllowed('viewWidgetsCustomerManagement') && (
                  <div className="status-blocks">
                    <div className="status-block">
                      <div className="breating-area">
                        {isLoader ? <Skeleton circle="true" height={35} width={35} /> : <FaUserFriends className="icon-inner-color" size={35} />}
                      </div>
                      <div className="status-info">
                        <h1>{isLoader ? <Skeleton height={15} width={100} /> : totalUserCount}</h1>
                        <p>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.totalUsers')}</p>
                      </div>
                    </div>

                    <div className="status-block">
                      <div className="breating-area">
                        {isLoader ? <Skeleton circle="true" height={35} width={35} /> : <FaUserAlt className="icon-inner-color" size={35} />}
                      </div>
                      <div className="status-info">
                        <h1>{isLoader ? <Skeleton height={15} width={100} /> : activeusers}</h1>
                        <p>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.activeUsers')}</p>
                      </div>
                    </div>

                    <div className="status-block">
                      <div className="breating-area">
                        {isLoader ? <Skeleton circle="true" height={35} width={35} /> : <FaUserAlt className="icon-inner-color" size={35} />}
                      </div>
                      <div className="status-info">
                        <h1>{isLoader ? <Skeleton height={15} width={100} /> : inactiveUser}</h1>
                        <p>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.inActiveUsers')}</p>
                      </div>
                    </div>

                    <div className="status-block">
                      <div className="breating-area">
                        {isLoader ? (
                          <Skeleton circle="true" height={35} width={35} />
                        ) : (
                          <FaAndroid color="#be210b" className="icon-inner-color" size={35} />
                        )}
                      </div>
                      <div className="status-info">
                        <h1>{isLoader ? <Skeleton height={15} width={100} /> : androidUser}</h1>
                        <p>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.android')}</p>
                      </div>
                      <div className="breating-area status-blue">
                        {isLoader ? (
                          <Skeleton circle="true" height={35} width={35} />
                        ) : (
                          <FaApple color="#3c7cdd" className="icon-inner-color" size={35} />
                        )}
                      </div>
                      <div className="status-info">
                        <h1>{isLoader ? <Skeleton height={15} width={100} /> : iosUser}</h1>
                        <p>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.iOS')}</p>
                      </div>
                    </div>
                  </div>
                )}

                <Card style={{ border: 'none', borderRadius: 'none' }}>
                  <div className="customer-details-search--block" style={{ border: 'none', borderRadius: 'none' }}>
                    <Row>
                      <Col
                        xl={`${showSearchBar ? 4 : 'auto'}`}
                        md={`${showSearchBar ? 12 : 'auto'}`}
                        className={`${showSearchBar ? '' : 'data-report-search-box'}`}
                      >
                        {showSearchBar ? search : searchIcon}
                      </Col>
                      <Col xl={`${showSearchBar ? 'auto' : 'auto'}`} md={`${showSearchBar ? 'auto' : 'auto'}`}>
                        <div className="data-report-date_picker">
                          <DateTimePicker
                            onChangeOfStartDate={(item) => setStartDate(item)}
                            onChangeOfEndDate={(item) => setEndDate(item)}
                            initialValueOfStartDate={moment().startOf('day')}
                            initialValueOfEndDate={moment(new Date()).endOf('day')}
                          />
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'}>
                        <div className="customerList-add-boxButton" onClick={() => dataFilter(searchText)}>
                          <Button className="customerList-add-box-Btn">{t('button.search')}</Button>
                        </div>
                      </Col>
                      <Col xl={'auto'} md={4}>
                        <div className="report-search-excel-block">
                          <div className="advance-filter-btn" onClick={() => setShowAdvanceFilterPopup(true)}>
                            <Button className="report-search-button">
                              <FaFilter className="hide-lap" />
                              <span>{t('button.advancedFilter')}</span>
                            </Button>
                          </div>
                        </div>
                      </Col>
                      <Col xl={'auto'} md={'auto'} className="excel-icon--block" onClick={downloadFile}>
                        {isLoading ? (
                          <div className="loader--block">
                            <Spinner as="span" animation="border" size="sm" role="status" />
                          </div>
                        ) : (
                          <div className="report-excel-icon">
                            <BsDownload size={28} color={'#3c7cdd'} />
                          </div>
                        )}
                      </Col>
                      <Col
                        xl={`${currentUserRole === 'super_admin' ? 12 : !_.isEmpty(manageCustomerPermissions) ? 10 : 12}`}
                        md={`${currentUserRole === 'super_admin' ? 12 : !_.isEmpty(manageCustomerPermissions) ? 8 : 12}`}
                      ></Col>
                    </Row>
                    <Row>
                      <Col>
                        {chips.map((chip) => (
                          <Chip key={chip.key} label={chip.label} color="error" onDelete={() => handleDeleteChip(chip.key)} sx={{ mr: 1 }} />
                        ))}
                        {chips.length > 1 && <Chip label="Clear all" color="error" onClick={handleClearAllFilters} sx={{ ml: 2 }} />}
                      </Col>
                    </Row>
                    {/* <Col xl={6} md={10} className="date-picker">
                      <DateTimePicker
                        onChangeOfStartDate={(item) => setStartDate(item)}
                        onChangeOfEndDate={(item) => setEndDate(item)}
                        initialValueOfStartDate={moment().startOf('month')}
                        initialValueOfEndDate={moment(new Date()).endOf('day')}
                      />
                    </Col> */}
                    {/* {currentUserRole !== 'super_admin' &&
                      (!_.isEmpty(manageCustomerPermissions) || (!_.isEmpty(getCustomerPermissions) && !_.isEmpty(manageCustomerPermissions))) && (
                        <Col xl={2} md={4} className="customerList-add-boxButton">
                          <Button
                            className="customerList-add-box-Btn"
                            onClick={() => {
                              setShowForm(true);
                              setIsEdit(false);
                            }}
                          >
                            Add Customer
                          </Button>
                        </Col>
                      )}
                  */}
                  </div>
                  {/* <div className="customer-details-inner">
                  <Row className="customer-details-block">
                    <Col xl={4} md={6} className="customer-details-wrapper">
                      <CustomerInfoBlock icon={<FiUsers color="#3C7CDD" />} title={totalData} subtitle={'Total Customer'} />
                    </Col>
                    <Col xl={4} md={6} className="customer-details-wrapper">
                      <CustomerInfoBlock icon={<FiUsers color="#3C7CDD" />} title={0} subtitle={'New Customer'} />
                    </Col>
                    <Col xl={4} md={6} className="customer-details-wrapper">
                      <CustomerInfoBlock icon={<FiUsers color="#3C7CDD" />} title={0} subtitle={'Customer using chargers'} />
                    </Col>
                  </Row>
                </div> */}
                </Card>
              </div>
              <div
                className="new-customer-list"
                style={{ backgroundColor: 'none', transform: 'translateY(-30px)', border: 'none', borderRadius: 'none' }}
              >
                <Card style={{ backgroundColor: 'none', transform: 'translateY(-30px)', border: 'none', borderRadius: 'none' }}>
                  {/* <div className="customer-text">{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.customerDetails')}</div> */}
                  <div className="customer-list-table">
                    <div className="table-responsive">
                      <table className="">
                        <thead>
                          <tr>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.customerName')}</span>
                              </div>
                            </th>
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.contactDetails')}</span>
                              </div>
                            </th>
                            {isAdminRoute && (
                              <th>
                                <div className="sorting">
                                  <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.tenant')}</span>
                                  <span className="ico" onClick={() => handleSorting('tenant', sortByItem)}>
                                    <BiSort size={15} />
                                  </span>
                                </div>
                              </th>
                            )}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.walletBalance')}</span>
                                <span className="ico" onClick={() => handleSorting('wallet_balance', sortByItem)}>
                                  <BiSort size={15} />
                                </span>
                              </div>
                            </th>
                            {/* <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.chargeCoin')}</span>
                              </div>
                            </th> */}
                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.rfidTag')}</span>
                              </div>
                            </th>
                            {/* <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.currentLevel')}</span>
                              </div>
                            </th> */}
                            {isAdvanceFilterAvailable && (
                              <>
                                <th>
                                  <div className="sorting">
                                    <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.sessionCount')}</span>
                                  </div>
                                </th>
                                <th>
                                  <div className="sorting">
                                    <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.avgRating')}</span>
                                  </div>
                                </th>
                              </>
                            )}

                            <th>
                              <div className="sorting">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.appType')}</span>
                              </div>
                            </th>
                            {/* {currentUserRole === 'super_admin' && (
                              <th className="action-col">
                                <span>{isLoader ? <Skeleton height={15} width={100} /> : t('addCustomerList.action')}</span>
                              </th>
                            )} */}
                          </tr>
                        </thead>
                        <tbody>
                          {isLoader ? (
                            // If loading, display a loading skeleton
                            <tr className="customer-row">
                              <td className="customer-cell border-0">
                                <Skeleton height={15} width={100} />
                              </td>
                            </tr>
                          ) : _.isEmpty(customerData) ? (
                            // If no data, display a message
                            <tr className="customer-row">
                              <td className="customer-cell border-0" colSpan={5}>
                                <div className="empty-data-block">{t('customerList.noData')}</div>
                              </td>
                            </tr>
                          ) : (
                            // Map through customer data and display each item in a row
                            _.map(customerData, (item, key) => {
                              const rfidTag = item.rfid ? _.head(_.map(item.rfid, (data) => data.code)) : '';
                              const hasAndroidToken = item.androidToken ? true : false;
                              const hasIosToken = item.iosToken ? true : false;
                              const tenant = item.tenant ? item.tenant.name : '';
                              return (
                                <tr
                                  key={`customer-${key}`}
                                  className="customer-row"
                                  onClick={() =>
                                    navigateTo(isAdminRoute ? `/customerProfileAdmin/${_.get(item, 'id')}` : `/customerProfile/${_.get(item, 'id')}`)
                                  }
                                >
                                  <td>
                                    <div className="avatar-with-name">
                                      {isLoader ? <Skeleton circle="true" height={15} width={15} /> : <FaRegUser size={25} color="#3c7cdd" />}
                                      <span className="customer-name">
                                        {isLoader ? (
                                          <Skeleton height={15} width={100} />
                                        ) : _.isEmpty(_.get(item, 'first_name')) && _.isEmpty(_.get(item, 'last_name')) ? (
                                          'Guest User'
                                        ) : !_.isEmpty(_.get(item, 'first_name')) && _.isEmpty(_.get(item, 'last_name')) ? (
                                          _.get(item, 'first_name')
                                        ) : (
                                          `${_.get(item, 'first_name')} ${_.get(item, 'last_name')}`
                                        )}
                                      </span>
                                    </div>
                                  </td>

                                  <td>
                                    {isLoader ? (
                                      <Skeleton height={15} width={100} />
                                    ) : (
                                      <div>
                                        <span
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            copyToClipboard(formatPhoneNumber(item), 'Phone number');
                                          }}
                                        >
                                          {formatPhoneNumber(item)}
                                        </span>
                                        <br />

                                        <span
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            copyToClipboard(_.get(item, 'email'), 'Email');
                                          }}
                                        >
                                          {_.get(item, 'email', '-')}
                                        </span>
                                      </div>
                                    )}
                                  </td>
                                  {isAdminRoute && <td>{tenant ? tenant : '-'}</td>}
                                  <td>
                                    <div className="wallet-rupee-icon">
                                      {isLoader ? (
                                        <Skeleton height={15} width={100} key="skeleton" />
                                      ) : (
                                        <>
                                          <FaRupeeSign size={12} />
                                          {roundOfDigit(_.get(item, 'wallet_balance'), 2)}
                                        </>
                                      )}
                                    </div>
                                  </td>
                                  {/* <td>
                                    {isLoader ? (
                                      <Skeleton height={15} width={100} />
                                    ) : (
                                      <div className="wallet-rupee-icon">
                                        <img src={chargeCoin} alt="Charge Coin" className="icon" />
                                        &nbsp;
                                        {item.charge_coin}
                                      </div>
                                    )}
                                  </td> */}
                                  <td>{rfidTag ? rfidTag : '-'}</td>
                                  {/* <td></td> */}
                                  {isAdvanceFilterAvailable && (
                                    <>
                                      <td>{item?.sessionCount ? item?.sessionCount : '-'}</td>
                                      <td>{item?.avgRating ? item?.avgRating : '-'}</td>
                                    </>
                                  )}

                                  <td>
                                    <div className="app-icons">
                                      {hasIosToken && <FaApple size={24} color="#ffffff" title="IOS" />}
                                      {hasAndroidToken && <IoLogoAndroid size={24} color="#ffffff" title="Android" />}
                                    </div>
                                  </td>

                                  {/* {currentUserRole === 'super_admin' && (
                                <td >
                                  <Button
                                    onClick={() => {
                                      setShowWalletForm(true);
                                      setCustomerList(item);
                                    }}
                                  >
                                    Do transaction
                                  </Button>
                                </td>
                              )} */}
                                </tr>
                              );
                            })
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {!(isLoader || _.isUndefined(isLoader)) && !_.isEmpty(customerData) && (
                    // <Pagination currentPage={page} limit={limit} total={totalData} onPageChange={(pageVal) => handlePageClick(pageVal)} />
                    <ReactPagination
                      currentPage={page}
                      limit={limit}
                      total={totalData}
                      handlePageClick={(pageVal) => handlePageClick(pageVal)}
                      totalPages={totalPages}
                      marginPagesDisplayed={1}
                    />
                  )}
                </Card>
              </div>
              {/*<div className="users-group-list--block">*/}
              {/*  <Card>*/}
              {/*    <div className="user-group-inner">*/}
              {/*      <div className="user-group-text">User Group</div>*/}
              {/*      <div className="upload-file-block">*/}
              {/*        <input onChange={showFile} type="file" id="file" className="upload-file--input" />*/}
              {/*        <label className="upload-file-inner" htmlFor="file">*/}
              {/*          <BsUpload color="#e12f17" />*/}
              {/*          <span className="upload-file-text">Upload</span>*/}
              {/*        </label>*/}
              {/*      </div>*/}
              {/*    </div>*/}
              {/*    <div className="users-group-list">*/}
              {/*      {file.length > 0 ? (*/}
              {/*        _.map(file, (item) => {*/}
              {/*          return (*/}
              {/*            <>*/}
              {/*              {item['type'] === 'image/jpeg' ? (*/}
              {/*                <UploadedUserList*/}
              {/*                  fileIcon={<AiOutlineFileJpg size={20} />}*/}
              {/*                  fileName={item.name}*/}
              {/*                  removeFile={() => onRemoveFile(item.name)}*/}
              {/*                />*/}
              {/*              ) : item['type'] === 'video/mp4' ? (*/}
              {/*                <UploadedUserList fileIcon={<FcVideoFile size={20} />} fileName={item.name} removeFile={() => onRemoveFile(item.name)} />*/}
              {/*              ) : item['type'] === 'application/zip' ? (*/}
              {/*                <UploadedUserList*/}
              {/*                  fileIcon={<BsFillFileEarmarkZipFill />}*/}
              {/*                  fileName={item.name}*/}
              {/*                  removeFile={() => onRemoveFile(item.name)}*/}
              {/*                />*/}
              {/*              ) : item['type'] === 'audio/mpeg' ? (*/}
              {/*                <UploadedUserList*/}
              {/*                  fileIcon={<FaRegFileAudio size={20} />}*/}
              {/*                  fileName={item.name}*/}
              {/*                  removeFile={() => onRemoveFile(item.name)}*/}
              {/*                />*/}
              {/*              ) : item['type'] === 'application/pdf' ? (*/}
              {/*                <UploadedUserList*/}
              {/*                  fileIcon={<AiOutlineFilePdf size={20} />}*/}
              {/*                  fileName={item.name}*/}
              {/*                  removeFile={() => onRemoveFile(item.name)}*/}
              {/*                />*/}
              {/*              ) : item['type'] === ('application/vnd.ms-excel' || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ? (*/}
              {/*                <UploadedUserList*/}
              {/*                  fileIcon={<RiFileExcel2Line size={20} />}*/}
              {/*                  fileName={item.name}*/}
              {/*                  removeFile={() => onRemoveFile(item.name)}*/}
              {/*                />*/}
              {/*              ) : (*/}
              {/*                <UploadedUserList*/}
              {/*                  fileIcon={<AiOutlineFile size={20} />}*/}
              {/*                  fileName={item.name}*/}
              {/*                  removeFile={() => onRemoveFile(item.name)}*/}
              {/*                />*/}
              {/*              )}*/}
              {/*            </>*/}
              {/*          );*/}
              {/*        })*/}
              {/*      ) : (*/}
              {/*        <div className="empty-data-block">No Files</div>*/}
              {/*      )}*/}
              {/*      /!* <UploadedUserList fileIcon={<RiFileExcel2Line />} fileName={'User_Group2.xls'} /> *!/*/}
              {/*    </div>*/}
              {/*  </Card>*/}
              {/*</div>*/}
            </div>
          </div>
        </SkeletonTheme>
        {showAdvanceFilterPopup && (
          <OffCanvas show={showAdvanceFilterPopup} onClose={onCloseAdvanceFilterPopup}>
            <Formik
              initialValues={initialValues}
              validationSchema={advanceFilterSchema}
              validateOnChange={false}
              validateOnBlur={false}
              onSubmit={(values, { setSubmitting }) => {
                const updatedValues = {};
                if (values.sessionCount) {
                  updatedValues.sessionCount = values.sessionCount;
                  updatedValues.sessionOperator = values.sessionOperator;
                }
                if (values.avgRating) {
                  updatedValues.avgRating = values.avgRating;
                  updatedValues.avgOperator = values.avgOperator;
                }
                handleAdvanceFilter(updatedValues);
                handleAdvanceFilterData(updatedValues);
                setSubmitting(false);
              }}
            >
              {({ values, errors, handleSubmit, handleChange, setFieldValue, resetForm }) => {
                const isNotFilled = (v) => v === null || v === undefined || v === '';
                const isFilled = (v) => !isNotFilled(v);
                return (
                  <Form onSubmit={handleSubmit}>
                    <div className="mb-5">
                      <div className="canvas-selection__block">
                        <TextInput
                          label={t('customerFilter.sessionCount')}
                          type="number"
                          placeholder={t('customerFilter.sessionCount')}
                          name="sessionCount"
                          value={_.get(values, 'sessionCount')}
                          onChange={handleChange}
                          error={errors.sessionCount ? errors.sessionCount : null}
                        />
                        {isFilled(values.sessionCount) && (
                          <Select
                            isRequired
                            label={t('customerFilter.sessionOperator')}
                            options={operatorOptions}
                            placeholder={t('customerFilter.selectOperator')}
                            name="sessionOperator"
                            value={values.sessionOperator}
                            onChange={(val) => setFieldValue(`sessionOperator`, val)}
                            error={errors.sessionOperator ? errors.sessionOperator : null}
                          />
                        )}
                        <TextInput
                          label={t('customerFilter.avgRating')}
                          type="number"
                          step="0.1"
                          placeholder={t('customerFilter.avgRating')}
                          name="avgRating"
                          value={_.get(values, 'avgRating')}
                          onChange={handleChange}
                          error={errors.avgRating ? errors.avgRating : null}
                        />
                        {isFilled(values.avgRating) && (
                          <Select
                            isRequired
                            label={t('customerFilter.avgOperator')}
                            options={operatorOptions}
                            placeholder={t('customerFilter.selectOperator')}
                            name="avgOperator"
                            value={values.avgOperator}
                            onChange={(val) => setFieldValue(`avgOperator`, val)}
                            error={errors.avgOperator ? errors.avgOperator : null}
                          />
                        )}
                      </div>
                    </div>
                    <div className="canvas-btn__block">
                      <Button type="submit" className="apply--btn w-100" disabled={isNotFilled(values.sessionCount) && isNotFilled(values.avgRating)}>
                        {t('button.applyFilters')}
                      </Button>
                      <div
                        className="reset--block"
                        onClick={() => {
                          getCustomer({ from: moment(startDate).utc(), to: moment(endDate).utc() });
                          resetForm();
                          onCloseAdvanceFilterPopup();
                          setAdvanceFilterData({});
                        }}
                      >
                        <MdClear size={24} className="reset--icon" />
                        {t('button.clear')}
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </OffCanvas>
        )}
        {showForm && (
          <Modal show={showForm} size="xl" centered>
            <CustomerForm onClose={handleCloseFormCustomer} isEdit={isEdit} />
          </Modal>
        )}
        {showWalletForm && (
          <Modal show={showWalletForm} size="lg" centered>
            <div className="wallet-transaction_main">
              <Card>
                <div className="wallet-transaction-header__block">
                  <div className="wallet-transaction-name">
                    <span>{t('customerDetail.walletTransaction')}</span>
                  </div>
                  <div className="close-btn">
                    <MdClose size={30} color="#be210b" onClick={handleClose} />
                  </div>
                </div>
                <div className="wallet-transaction_form">
                  <Formik
                    initialValues={{
                      amount: '',
                      user: _.get(customerList, 'id', ''),
                      type: '',
                      message: '',
                    }}
                    validationSchema={WalletTransactionSchema}
                    onSubmit={(values, { setSubmitting }) => {
                      walletTransaction(values);
                      setSubmitting(false);
                    }}
                  >
                    {({ values, errors, touched, setFieldValue, handleSubmit, handleChange, isSubmitting }) => (
                      <Form onSubmit={handleSubmit}>
                        <Row>
                          <Col lg={6}>
                            <TextInput
                              isRequired
                              label={t('customerDetail.walletAmount')}
                              type="number"
                              placeholder={t('customerDetail.walletAmount')}
                              name="amount"
                              value={_.get(values, 'amount')}
                              onChange={handleChange}
                              error={errors.amount && touched.amount ? errors.amount : null}
                            />
                          </Col>
                          <Col lg={6}>
                            <Select
                              isRequired
                              label={t('customerDetail.walletType')}
                              options={[
                                { label: 'Credit', value: 'credit' },
                                { label: 'Debit', value: 'debit' },
                              ]}
                              placeholder={t('placeHolder.selectType')}
                              name="type"
                              value={values.type}
                              onChange={(val) => setFieldValue(`type`, val)}
                              error={errors.type && touched.type ? errors.type : null}
                            />
                          </Col>
                          <Col lg={12}>
                            <TextInput
                              isRequired
                              as="textarea"
                              rows="4"
                              inputClass="scrollable"
                              placeholder={t('customerDetail.walletMessage')}
                              label={t('customerDetail.walletMessage')}
                              name="message"
                              value={values.message}
                              onChange={handleChange}
                              error={errors.message && touched.message ? errors.message : null}
                            />
                          </Col>
                        </Row>
                        <div className="wallet-transaction_button">
                          <Button className="wallet-transaction-btn cancel_btn" onClick={handleClose}>
                            {t('button.cancel')}
                          </Button>
                          <Button type="submit" disabled={isSubmitting} className="wallet-transaction-btn create-btn">
                            {t('button.submit')}
                          </Button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </Card>
            </div>
          </Modal>
        )}
        {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
      </LayoutContainer>
    </>
  );
};
export default CustomerList;

const CustomerInfoBlock = (props) => {
  const { icon, title, subtitle } = props;
  return (
    <div className="customer-info--box">
      <div className="customer-info-icon">{icon}</div>
      <div className="customer-info--wrapper">
        <div className="total-customer">{title}</div>
        <div className="info-text">{subtitle}</div>
      </div>
    </div>
  );
};
CustomerInfoBlock.propTypes = {
  icon: PropTypes.object,
  title: PropTypes.number,
  subtitle: PropTypes.string,
};

// const UploadedUserList = (props) => {
//   const { fileIcon, fileName, removeFile } = props;
//   return (
//     <div className="users-group-list-wrapper">
//       <div className="user-group--name">
//         <span>{fileIcon}</span>
//         <span className="list-text">{fileName}</span>
//       </div>
//       <div className="users-group-list-icon" onClick={removeFile}>
//         <RiDeleteBin6Line />
//       </div>
//     </div>
//   );
// };
// UploadedUserList.propTypes = {
//   fileIcon: PropTypes.object,
//   fileName: PropTypes.string,
//   removeFile: PropTypes.func,
// };
